import { toSnakeCase, tracking } from '@utils';
import zendesk from '@services/zendesk.service';

function extractUtmParams(url) {
  const urlObject = new URL(url);
  const utmParams = {};

  urlObject.searchParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  });

  return utmParams;
}

export default {
  namespaced: true,

  actions: {
    event: (store, { category, event, props }) => {
      const eventName = `${category}_${event}`;
      // catch missing events for the areas where provider views are loaded into
      // the admin UI
      try {
        window.MetaEvents.event(eventName, toSnakeCase(props));
      } catch (error) {
        console.warn(error); // eslint-disable-line no-console
      }
    },

    pageLoad: (store, path) => {
      window.analytics.page(path);
    },

    identifyUser: (store, { id, traits }) => {
      zendesk.identifyUser(traits);

      const utmParams = extractUtmParams(document.URL);

      tracking.identifyUser(id, toSnakeCase({ ...traits, ...utmParams }));

      if (process.env.HOST !== 'www.kinside.com') {
        console.info('Identified user', id, { traits, utmParams }); // eslint-disable-line no-console
      }
    },
  },
};
